import { UnitOfMeasure } from "../../lib/models"
import useAPI from "./use-api"

const useProductMeasurements = () => {
  return useAPI<UnitOfMeasure[]>("/products/measurements")
}

export default useProductMeasurements
